import axios from 'axios/index'
import LoginUtils from '@/core/utils/login-utils'

export default {

  jalekoAPI: function () {
    return axios.create({
      baseURL: process.env.VUE_APP_JALEKO_BASE_API_URL,
      raxConfig: {
        retry: 3,
        retryDelay: 3000
      }
    })
  },

  secureJalekoAPI: function () {
    const token = LoginUtils.getToken()

    if (!token) {
      window.location = '/login'
    }

    let api = axios.create({
      baseURL: process.env.VUE_APP_JALEKO_BASE_API_URL,
      headers: { 'Authorization': 'Bearer ' + token }
    })

    api.interceptors.response.use(response => response, error => {
      if (error.response) {
        if (error.response.status === 0) {
          window.location = '/error?error=1&redir=' + window.location.pathname
        }
        if (error.response.status === 401) {
          LoginUtils.logout()
          LoginUtils.setMotivoDispositivosLogoutForcado()
          LoginUtils.removeMotivoSessaoLogoutForcado()
          window.location = '/login'
        }
        throw error
      }
    })

    api.interceptors.response.use(response => {
      if (!response || response.status === 0) {
        window.location = '/error?error=2&redir=' + window.location.pathname
      }
      return response
    })

    return api
  },

  jalekoBuscaAPI: function () {
    return axios.create({
      baseURL: process.env.VUE_APP_JALEKO_BUSCA_BASE_API_URL
    })
  },

  ibgeAPI: function () {
    return axios.create({
      baseURL: 'https://servicodados.ibge.gov.br/api/v1'
    })
  },

  restcountriesAPI: function () {
    return axios.create({
      baseURL: 'https://restcountries.eu/rest/v2'
    })
  },

  eventosAPI: function () {
    return axios.create({
      baseURL: process.env.VUE_APP_API_EVENTOS_URL
    })
  },

  ltiAPI: function () {
    const token = LoginUtils.getToken()

    return axios.create({
      baseURL: process.env.VUE_APP_API_LTI_URL,
      headers: { 'Authorization': 'Bearer ' + token }
    })
  },

  jaleklinicoAPI: function () {
    const token = LoginUtils.getToken()

    return axios.create({
      baseURL: process.env.VUE_APP_API_JALEKLINICO,
      headers: { 'Authorization': 'Bearer ' + token }
    })
  },

  npsAPI: function () {
    let token = localStorage.getItem('tokenAccessUserNps')

    return axios.create({
      baseURL: localStorage.getItem('baseUrlNps'),
      headers: { 'Authorization': 'Bearer ' + token }
    })
  }
}
